<section class="crawlable-categories">
  <ul>
    <li *ngFor="let category of categories">
      <a [routerLink]="['/c', category.slug]">{{ category.name }}</a>
    </li>
  </ul>
</section>
